export function formatNumberToString(number: number): string {
  if (number === null) {
    return '0,0';
  }
  return number.toFixed(1).replace('.', ',');
}
